<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />

    <div>
        <div class="form-edit-page row-space">
            <div class="row row-space">
                <div class="form-item-char10">
                    <label class="label-caption">Código</label>
                    <div class="field-label field-label-end">{{ Funcoes.formatInteger(objEdicao.id) }}</div>
                </div>
                <div class="form-item-char20">
                    <label class="label-caption">Protocolo</label>
                    <div class="field-label field-label-center">{{ objEdicao.xsequencia }}</div>
                </div>
                <div class="form-item-char20">
                    <label class="label-caption">Data Lançamento</label>
                    <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objEdicao.dtlancamento) }}</div>
                </div>
                <div class="form-item-char20">
                    <label class="label-caption">Protocolo Vistoria</label>
                    <div class="field-label field-label-center">{{ objEdicao.xsequencia_pla06 }}</div>
                </div>
                <div class="form-item-char20">
                    <label class="label-caption">Data Vistoria</label>
                    <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objEdicao.dtvistoria) }}</div>
                </div>
                <div class="form-item">
                    <label class="label-caption">Status</label>
                    <div class="field-label">{{ objEdicao.xstatus }}</div>
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Estabelecimento</label>
                    <div class="field-label field-label-start">{{ objEdicao.nmestabelecimento }}</div>
                </div>
                <button type="button" class="buttom-icon--close" @click="closeForm" />
            </div>
        </div>
    </div>

    <div v-for="item in lsItens" :key="item.id" class="form-edit-page row-space">
        <div class="tela-dividida row-space">
            <div class="coluna">
                <div class="form-item-char15">
                    <label class="label-caption">PAC</label>
                    <div class="field-label field-label-center field-label--destaque">{{ item.nmpac }}</div>
                </div>

                <div class="form-item-char15">
                    <label class="label-caption">Prazo</label>
                    <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(item.dtprazo) }}</div>
                </div>                
            </div>

            <div class="coluna">
                <div class="form-item-data">
                    <label class="label-caption">Data Prevista</label>
                    <input type="date" v-model="item.acdtprevista" @input="item.editado = true" />
                </div>
                <button v-if="item.editado" class="btn-confirm" @click="salvarItem(item)">Salvar</button>
            </div>
        </div>


        <div class="tela-dividida">
            <div class="coluna">
                <div class="form-item">
                    <label class="label-caption">Não Conformidade</label>
                    <textarea v-model="item.pacobs" rows="5" maxlength="3000" readonly/>
                </div>
            </div>

            <div class="coluna">
                <div class="form-item">
                    <label class="label-caption">Ação Corretiva</label>
                    <textarea v-model="item.acdetalhamento" rows="5" maxlength="3000" @input="item.editado = true"/>
                </div>
            </div>
        </div>
    </div>


    <div class="row-end">
        <button class="btn-cancel" @click="encerrarDigitacao">Encerrar e Assinar</button>
    </div>
    
    <DialogOkModal 
        v-if="showOkModal" 
        :message="msgOkModal" 
        @close="closeForm" 
        @confirmed="closeForm" />

    <SenhaModal ref="senhaModalRef" />
</template>
  
<script setup>
import { onMounted, ref } from 'vue';
import { criarAssinatura } from '@/models/assinatura';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import DialogOkModal from '@/components/modals/DialogOkModal.vue';
import MensagemAlerta from '@/components/utils/MensagemAlerta.vue';
import SenhaModal from '@/components/modals/SenhaModal.vue';

const emit = defineEmits(['close', 'save']);
const props = defineProps({idEdicao: {type: Number, default: 0}});
const senhaModalRef = ref(null);

const isLoading = ref(false);
const lsItens = ref([]);
const msgAlerta = ref(null);
const msgOkModal = ref('Relatório encerrado e aguardando conferência.');
const objAssinatura = ref(criarAssinatura());
const objEdicao = ref({});
const showOkModal = ref(false);


const closeForm = () => {
    emit('save');
    emit('close'); 
}


async function encerrarDigitacao(){
    try{
        if (lsItens.value.filter(a => a.editado).length > 0) throw new Error('Necessário salvar todos os ítens');
        if (lsItens.value.filter(a => !a.acdtprevista).length > 0) throw new Error('Necessário preenchimento de todos os ítens');
        msgAlerta.value=null;

        const senhaDigitada = await senhaModalRef.value.showModal();
        if (!senhaDigitada) return;
        
        objAssinatura.value.idep = globalStore.idep;
        objAssinatura.value.idusuario = globalStore.idusuario;
        objAssinatura.value.idsessao = globalStore.idlogin;
        objAssinatura.value.nmusuario = globalStore.nmusuario;
        objAssinatura.value.vssistema = `${globalStore.appname} vs. ${globalStore.appver}`;
        objAssinatura.value.ass_conteudo = `REF:PLA08|IDREF:${objEdicao.value.id}|PROT:${objEdicao.value.xsequencia}`;
        objAssinatura.value.ass_senha = senhaDigitada;
        objAssinatura.value.ass_tipoauth = 'senha pessoal via sistema WEB';
        objAssinatura.value.doc_idorigem = objEdicao.value.id;
        objAssinatura.value.doc_tipo = 'PLA08';

        const respAss = await Api.genericPut('/pla/assinar', objAssinatura.value);
        if (respAss.bolok === 1){
            showOkModal.value=true;
        } else {
            msgAlerta.value=`ATENÇÃO: ${respAss.erro}`;
        }
    } catch (error) {msgAlerta.value=`ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}


const lerDados = async() => {
    try{
        isLoading.value=true;
        msgAlerta.value=null;
        
        if (!objEdicao.value.id){
            // SELECIONA OBJETO PRINCIPAL
            const rPla08 = await Api.genericPost('/lspla/pla08', {idep: globalStore.idep, id: props.idEdicao});
            objEdicao.value = rPla08[0];
        }

        const rItens = await Api.genericPost('/lspla/pla08_itens', {id: props.idEdicao});
        lsItens.value = rItens.map(item => ({
            ...item,
            editado: false
        }));

    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value=false;}
}


async function salvarItem(obj) {
    try {
        if (!obj.acdtprevista) throw new Error('Informe o prazo');
        if (!obj.acdetalhamento) throw new Error('Informe detalhamento da ação corretiva');
        isLoading.value = true;
        msgAlerta.value = null;

        const response  = await Api.genericPut('/cad/pla08_item', {
            id: obj.id,
            acdtprevista: obj.acdtprevista,
            acdetalhamento: obj.acdetalhamento,
            idlogin: globalStore.idlogin,
            idusuario: globalStore.idusuario});
        if (response.bolok === 1){
            obj.editado = false;
        }else{
            msgAlerta.value=response.erro;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally{isLoading.value=false;}
}


onMounted(lerDados);
</script>


<style scoped>
.tela-dividida {
    display: flex;
    gap: 10px;
    box-sizing: border-box;
}

.coluna {
    flex: 1;
    display: flex;
    gap: 10px;
    align-items: end;
}

.esquerda {
    background-color: #3498db;
}

.direita {
    background-color: #2ecc71;
}
</style>
